import request from "@utils/request";
export function getOrderTime(data) {
  return request({
    url: "/website/carOrder/noAuth/front/v3.2.10/getOrderTime?type=refresh",
    method: "get",
    params: data,
  });
}

export function getAgreeList(data) {
  return request({
    url: `/community/agreementMange/noAuth/front/ssh/v3.2.11/searchAgreementMange?id=${data}`,
    method: "GET",
    params: data,
  });
}

// 车系枚举
export function getCarSeries() {
  return request({
    url: `/order/carOrder/dict/noAuth/front/ssh/carSeries`,
    method: "GET",
  });
}

// 首页试驾
export function getTestDrive() {
  return request({
    url: `/order/carConfigAtt/noAuth/front/officialWebsite/testDrive`,
    method: "GET",
  });
}
